class CustomVideo extends HTMLElement {
  constructor() {
    super();
    this.variantChanger = this.closest("variant-listener");
    this.mainProduct = document.querySelector("main-product");
    this.pauseOnClick = this.dataset.pauseOnClick;
    this.playMode = this.dataset.playMode;
    this.playButton = this.querySelector(".custom-play--button");
    this.muteButton = this.querySelector(".custom-mute--button");
  }
  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll("video"));
    window.addEventListener("load", () =>
      this.initializeVideoLoad("window-load")
    );
    if (this.variantChanger) {
      this.variantChanger.addEventListener(
        "change-finished",
        this.initializeVideoLoad.bind(this, "variant-event"),{once: true}
      );
    }
  }

  initializeVideoLoad(event) {
    if (event === "variant-event") {
      this.videos = Array.from(document.querySelectorAll("custom-video video"));
    }
    this.sources = this.videos.map((video) => video.querySelector("source"));
    this.visibleVideos = this.videos.filter(
      (video) => getComputedStyle(video).display !== "none"
    );
    this.video = this.visibleVideos[0];
    if (this.video) {
      this.load();
    }
    this.videos.forEach((video, index) => {
      const isMobileOnly = video.classList.contains("mobile-only");
      const isDesktopOnly = video.classList.contains("desktop-only");
      if ((isMobile() && isMobileOnly) || (!isMobile() && isDesktopOnly)) {
        const source = this.sources[index];
        if (source) {
          source.setAttribute("src", source.dataset.src);
        }
        video.removeChild(source);
        video.appendChild(source);
      }
    });
    if (this.videos.length) {
      if ("IntersectionObserver" in window) {
        this.startObserving();
      } else {
        this.videos.forEach((video) => this.handleAutoPlay(video));
      }
    }
  }
  handleAutoPlay(video) {
    video.play().then().catch(error => {
      console.error('Autoplay is not allowed:', error);
    })
  }
  startObserving() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust this threshold as needed
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.paused) this.handleAutoPlay(video);
        } else {
          if (!video.paused) video.pause();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    this.videos.forEach((container) => {
      observer.observe(container);
    });
  }
  load() {
    if (this.muteButton) {
      this.muteButton.addEventListener("click", this.toggleMute.bind(this));
    }
    if (this.playMode === "on-hover") {
      this.playOnHover();
    } else if (this.playButton && this.pauseOnClick) {
      this.playButton.addEventListener("click", this.togglePlay.bind(this));
    }
  }

  togglePlay() {
    if (this.video.paused || this.video.ended) {
      this.playButton.classList.add("paused");
      this.handleAutoPlay(this.video);
    } else {
      this.playButton.classList.remove("paused");
      this.video.pause();
    }
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
    if (this.video.muted === true) {
      this.muteButton.classList.add("muted");
    } else {
      this.muteButton.classList.remove("muted");
    }
  }

  playOnHover() {
    // add "data-play-mode-trigger" on the parent that you want to trigger the hover action
    const hoverTrigger = this.closest("[data-play-mode-trigger]") || this;

    hoverTrigger.addEventListener("mouseenter", () => {
      if (this.video.paused) this.handleAutoPlay(this.video);
    });

    hoverTrigger.addEventListener("mouseleave", () => {
      this.video.currentTime = 0;
      if (!this.video.paused) this.video.pause();
    });
  }
}

customElements.define("custom-video", CustomVideo);
